import { useNavigate, useLocation } from "react-router-dom";
import logo from "../assets/logo.png";

export default function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user"));

  function logout() {
    localStorage.clear();
    navigate("/");
  }

  function isActive(path) {
    return location.pathname.startsWith(path);
  }

  function canNavigateTo(href) {
    if (!href) return false;
    if (href === "/") return true;

    if (user?.role === "INSTRUCTOR") {
      return href === "/dashboard" || /^\/students\/\d+\/absences$/.test(href);
    }

    if (user?.role === "COORDINATION") {
      return (
        href === "/coordinator" ||
        href === "/analytics" ||
        href === "/analytics/evasions" ||
        href === "/analytics/attendance-report" ||
        href === "/instructors" ||
        href === "/classes" ||
        href === "/students" ||
        /^\/coordinator\/kanban\/[^/]+$/.test(href) ||
        /^\/students\/\d+\/details$/.test(href)
      );
    }

    return false;
  }

  function getBreadcrumbs() {
    const path = location.pathname;
    const map = {
      "/dashboard": "Minhas Turmas",
      "/coordinator": "Acompanhamento",
      "/coordinator/kanban": "Kanban",
      "/analytics": "Dashboard Analitico",
      "/analytics/evasions": "Alunos Evadidos",
      "/analytics/attendance-report": "Relatorio de Frequencia",
      "/instructors": "Instrutores",
      "/classes": "Turmas",
      "/students": "Alunos",
    };

    if (path === "/") return [];

    const parts = path.split("/").filter(Boolean);
    const crumbs = [{ label: "Inicio", href: user?.role === "COORDINATION" ? "/coordinator" : "/dashboard" }];

    const fullPath = parts.reduce((acc, part) => {
      const next = `${acc}/${part}`;
      const label = map[next] || map[acc] || part;
      crumbs.push({ label, href: next });
      return next;
    }, "");

    if (fullPath.startsWith("/students/") && fullPath.endsWith("/details")) {
      crumbs.pop();
      crumbs.push({ label: "Detalhes do Aluno", href: fullPath });
    }

    if (fullPath.startsWith("/students/") && fullPath.endsWith("/absences")) {
      crumbs.pop();
      crumbs.push({ label: "Historico de Faltas", href: fullPath });
    }

    return crumbs.map((crumb) => ({
      ...crumb,
      clickable: canNavigateTo(crumb.href),
    }));
  }

  const breadcrumbs = getBreadcrumbs();

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-header">
          <img src={logo} alt="SIMF" className="sidebar-logo" />

          <div className="sidebar-title">
            Sistema para Monitoramento
            <br />
            de Frequencia
          </div>
        </div>

        <nav className="sidebar-menu">
          {user?.role === "INSTRUCTOR" && (
            <button
              className={`menu-item ${isActive("/dashboard") ? "active" : ""}`}
              onClick={() => navigate("/dashboard")}
            >
              Minhas Turmas
            </button>
          )}

          {user?.role === "COORDINATION" && (
            <>
              <button
                className={`menu-item ${isActive("/coordinator") ? "active" : ""}`}
                onClick={() => navigate("/coordinator")}
              >
                Acompanhamento
              </button>

              <button
                className={`menu-item ${isActive("/instructors") ? "active" : ""}`}
                onClick={() => navigate("/instructors")}
              >
                Instrutores
              </button>

              <button
                className={`menu-item ${isActive("/classes") ? "active" : ""}`}
                onClick={() => navigate("/classes")}
              >
                Turmas
              </button>

              <button
                className={`menu-item ${isActive("/students") ? "active" : ""}`}
                onClick={() => navigate("/students")}
              >
                Alunos
              </button>

              <button
                className={`menu-item ${isActive("/analytics") ? "active" : ""}`}
                onClick={() => navigate("/analytics")}
              >
                Dashboard Analitíco
              </button>

              <button
                className={`menu-item ${isActive("/analytics/attendance-report") ? "active" : ""}`}
                onClick={() => navigate("/analytics/attendance-report")}
              >
                Relatório de Frequência
              </button>
            </>
          )}
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">{user?.name}</div>

          <button className="logout-btn" onClick={logout}>
            Sair
          </button>
        </div>
      </aside>

      <main className="main-content">
        {breadcrumbs.length > 0 && (
          <div className="breadcrumb-bar">
            {breadcrumbs.map((crumb, index) => (
              <span key={crumb.href || index} className="breadcrumb-item">
                {index > 0 && <span className="breadcrumb-sep">/</span>}
                {crumb.clickable ? (
                  <button
                    type="button"
                    className="breadcrumb-link"
                    onClick={() => navigate(crumb.href)}
                  >
                    {crumb.label}
                  </button>
                ) : (
                  <span className="breadcrumb-link">{crumb.label}</span>
                )}
              </span>
            ))}
          </div>
        )}
        {children}
      </main>
    </div>
  );
}
